const ru = {
  /** Global */
  WELCOME: "Добро пожаловать",
  HI: "Привет",
  LANG: "Иврит",
  BACK_TO_HOME_PAGE: "Назад на главную страницу",
  INSTALL_APP: "Скачать приложение",
  NUM_IS_GREATER_ERROR: "Введите число меньше чем",
  NUM_IS_LESS_ERROR: "Введите число больше чем",
  DETAILS: "Детали",
  CLEAR: "Очистить",
  SAVE: "Сохранить",
  UPLOAD: "Загрузить",
  NEW: "Новый",
  CANCEL: "Отмена",
  EDIT: "Редактировать",
  DELETE: "Удалить",
  LOGOUT: "Выйти",
  ACCEPT: "Принять",
  ERROR: "Ошибка",
  CLOSE: "Закрыть",
  GOOD_AFTERNOON: "Добрый день",
  GOOD_EVENING: "Добрый вечер",
  GOOD_NIGHT: "Доброй ночи",
  GOOD_MORNING: "Доброе утро",
  PATH_EXISTS: "Идентификатор уже существует в системе — выберите другой идентификатор",
  CREATED: "Дата создания",
  NO_DATA: "Нет данных для отображения",
  QTY: "Количество",
  TYPE: "Тип",
  PRICE: "Цена",
  TEMPLATES: "Шаблоны",
  SEND: "Отправить",
  REFRESH: "Обновить",
  SEARCH: "Поиск",
  SAVED_SUCCESS: "Сохранено успешно",
  LINK_COPY_SUCCESS: "Ссылка успешно скопирована",
  UNLIMITED: "Без ограничений",
  ADMIN_AREA: "Административная зона",
  FREE: "Бесплатно",
  REMOVE: "Удалить",
  CONTINUE: "Продолжить",
  DELETE_INFO: "Обратите внимание — после удаления восстановить эти данные будет невозможно",
  DOWNLOAD: "Загрузить",
  PAY_ATTENTION: "Обратите внимание",
  SHOW: "Показать",
  DATE: "Дата",
  SUNDAY: "Воскресенье",
  MONDAY: "Понедельник",
  TUESDAY: "Вторник",
  WEDNESDAY: "Среда",
  THURSDAY: "Четверг",
  FRIDAY: "Пятница",
  SATURDAY: "Суббота",
  HELLO: "Здравствуйте",
  LAST_ACTIVE: "Последнее действие",
  COLOR: "Цвет",
  EMPLOYEE: "Сотрудник",
  DEPARTMENT_MANAGER: "Менеджер отдела",
  BIZ_MANAGER: "Менеджер бизнеса",
  ROLE: "Роль",
  LINK_COPY_SUCCESSFULLY: "Ссылка успешно скопирована",
  TABLE: "Таблица",
  CARDS: "Карты",
  STATUS: "Статус",
  ADD: "Добавить",
  ALL: "Все",
  FULL: "Полный",
  EMPTY: "Пусто",
  GLOBAL: "Общий",
  EMP_AND_DATES: "Расписание и время",
  PAYMENTS: "Платежи",
  EMPLOYEE_NAME: "Имя сотрудника",
  CREATE_GUID: "Создать идентификатор",
  CHECK_CONNECTED: "Проверить подключение",
  NETWORK_CONNECTION_GUIDE_TITLE: "Подключение устройства к сети",
  NETWORK_CONNECTION_GUIDE_1: "Откройте поиск сетей Wi-Fi на мобильном телефоне или компьютере",
  NETWORK_CONNECTION_GUIDE_2: "Найдите сеть с названием 'MyBee'",
  NETWORK_CONNECTION_GUIDE_3: "Нажмите подключиться и введите пароль, указанный на задней панели устройства",
  NETWORK_CONNECTION_GUIDE_4: "После этого откроется страница для подключения",
  NETWORK_CONNECTION_GUIDE_4_1: "Если страница не открылась, нажмите здесь",
  NETWORK_CONNECTION_GUIDE_5: "На открывшейся странице введите данные для подключения (имя сети и пароль)",
  NETWORK_CONNECTION_GUIDE_6: "Отправьте форму и подтвердите подключение устройства к сети",
  NETWORK_CONNECTION_GUIDE_7: "Нажмите 'Проверить подключение' внизу страницы",
  SET_ALL_ASTERISK_ERROR: "Пожалуйста, заполните все поля, отмеченные звездочкой*",
  TEST: "Тест",
  WS_IS_CONNECTED: "Подключено к сети",
  WS_IS_DISCONNECTED: "Отключено от сети",
  NUMBER_MUST_BE_BETWEEN: "Число должно быть между",
  NUMBER_MUST_BE_GREATER_THAN: "Число должно быть больше чем",
  NUMBER_MUST_BE_LESS_THAN: "Число должно быть меньше чем",
  SETTINGS_AND_ADMIN: "Настройки и администрирование",
  NO_PLUGIN: "У вас нет прав на открытие запроса — для получения дополнительной информации свяжитесь с поддержкой",
  HAS_TWO_FACTOR: "Включить двухфакторную аутентификацию",
  TWO_FACTOR_NEED_EMAIL_ERROR: 'Необходимо указать электронную почту для включения двухфакторной аутентификации',
  TWO_FACTOR_CODE: "Двухфакторная аутентификация",
  CODE: "Введите полученный код",
  TWO_FACTOR_SEND_EMAIL: 'Код аутентификации был отправлен на вашу электронную почту.',
  TWO_FACTOR_INPUT: 'Введите код для завершения процесса.',
  TWO_FACTOR_CODE_REQUIRED: "Необходимо ввести код аутентификации",
  SEND_AGAIN_TIMER: "Не получил код",
  SEND_AGAIN: "Отправить код повторно",
  SEND_CODE_SUCCESS: "Код успешно отправлен",
  SELECTED_LANG: "Выбор языка",
  LANGUAGE: "Язык",
  HE: "Иврит",
  EN: "Английский",
  AR: "Арабский",
  RU: "Русский",
  CHANGE_LANG_SUCCESS: "Язык успешно изменён",
  CHANGE_LANG_ERROR: "Не удалось изменить язык, пожалуйста, попробуйте снова",
  ICON: "Иконка",
  TITLE: "Заголовок",
  URL: "URL-адрес",

  /** Validations */
  REQUIRED: "Обязательное поле",
  URL_ERROR: "Введите правильный URL, например: https://www.google.com",
  CEL_ISRAELI_ERROR: "Введите правильный номер телефона",
  EMAIL_ERROR: 'Введите правильный электронный адрес',
  ONLY_NUMBER_ERROR: "Введите только цифры",
  PATH_ERROR:
    "Введите только буквы на английском и цифры (минимум 3, максимум 20 символов)",
  PASSWORD_ERROR:
    "Минимум 8 символов, хотя бы одна заглавная буква, одна строчная буква, цифра и специальный символ",

  /** Plans */
  servicesCall: "Служба поддержки",
  contactUs: "Контакты",
  schedule: "Расписание",
  PLANS: "Планы",
  maxClients: "Макс. количество клиентов",
  maxEmployees: "Макс. количество сотрудников",
  maxItems: "Макс. количество товаров",
  maxWebAppMessage: "Макс. количество сообщений",
  EVERY_MONTH: "Каждый месяц",
  SELECT_PLAN: "Выбрать план",
  ONLY_SYS_ADMIN: "Только для администраторов системы",
  SYS_NAME: "Имя в системе",

  /** Dates Reports */
  DATES: "Даты",
  START_DATE: "Дата начала",
  END_DATE: "Дата окончания",
  CREATE_REPORT: "Создать отчет",
  TODAY: "Сегодня",
  THIS_WEEK: "На этой неделе",
  THIS_MONTH: "В этом месяце",
  THIS_YEAR: "В этом году",
  ALL_EMPLOYEES: "Все сотрудники",
  PMT_TYPE: "Тип платежа",
  ALL_PMT: "Все виды платежей",
  ALL_STATUS: "Все статусы",

  /** Login */
  LOGIN: "Вход",
  CONNECT: "Подключиться",
  USER_NAME: "Имя пользователя",
  PASSWORD: "Пароль",
  HAS_SIGNIN: "У вас еще нет аккаунта?",
  SIGNIN_NOW: "Создайте аккаунт",
  KEEP_LIGIN: "Запомнить меня на этом устройстве",
  REMEMBER_ME: "Запомнить меня",
  LOGIN_ERROR: "Ошибка входа",
  LOGIN_SUCCESS: "Вы успешно вошли",

  /** Recommend */
  RECOMMEND: "Рекомендации",
  RECOMMEND_DESC: "Описание рекомендации",

  /** Templates */
  BASIC: "Базовый",
  CLASSIC: "Классический",
  WAVES: "Волны",
  BUBBLE: "Пузыри",
  TEMP_TYPE_ID: "Выбрать шаблон",
  CLASSIC_1: "Классический 1",
  DESIGN_1: "Дизайн 1",

  /** Signup */
  SIGNUP: "Давайте начнем",
  SIGNUP_NFO: "Краткая регистрация, и вы внутри",
  USER_DETAILS: "Данные пользователя",
  BIZ_DETAILS: "Данные бизнеса",
  BIZ_TEL: "Телефон бизнеса",
  BIZ_EMAIL: 'Электронная почта бизнеса',
  BIZ_DESC: "Информация о бизнесе",
  VALID_PASSWORD: "Подтверждение пароля",
  EMAIL_FOR_RESET_PASSWORD: 'Электронная почта для сброса пароля',
  HAS_LOGIN: "У вас уже есть аккаунт?",

  /** businessCard */
  businessCard: "Визитная карточка",

  //** Analytics */
  ANALYTICS: "Аналитика",

  /** Private Area */
  PRIVATE_AREA: "Личный кабинет",

  /** Plans */
  PLANS_MANAGEMENT: "Управление планами",
  servicesCall: "Служба вызова",
  contactUs: "Почта",
  schedule: "Расписание",
  PLANS: "Планы",
  maxClients: "Количество клиентов",
  maxEmployees: "Количество сотрудников",
  maxItems: "Количество товаров",
  maxWebAppMessage: "Количество сообщений",
  EVERY_MONTH: "Каждый месяц",
  SELECT_PLAN: "Выбрать план",
  ONLY_SYS_ADMIN: "Только для администраторов системы",
  SYS_NAME: "Имя в системе",

  /** Dates Reports */
  DATES: "Календарь",
  START_DATE: "Дата начала",
  END_DATE: "Дата окончания",
  CREATE_REPORT: "Создать отчет",
  TODAY: "Сегодня",
  THIS_WEEK: "На этой неделе",
  THIS_MONTH: "В этом месяце",
  THIS_YEAR: "В этом году",
  ALL_EMPLOYEES: "Все сотрудники",
  PMT_TYPE: "Статус оплаты",
  ALL_PMT: "Все типы оплаты",
  ALL_STATUS: "Все статусы",

  /** Login */
  LOGIN: "Вход",
  CONNECT: "Подключиться",
  USER_NAME: "Имя пользователя",
  PASSWORD: "Пароль",
  HAS_SIGNIN: "У вас еще нет аккаунта?",
  SIGNIN_NOW: "Зарегистрироваться",
  KEEP_LIGIN: "Запомнить меня на этом компьютере",
  REMEMBER_ME: "Запомнить меня",
  LOGIN_ERROR: "Ошибка входа",
  LOGIN_SUCCESS: "Вы успешно вошли",

  /** Recommend */
  RECOMMEND: "Рекомендации",
  RECOMMEND_DESC: "Описание рекомендации",

  /** Templates */
  BASIC: "Основной",
  CLASSIC: "Классический",
  WAVES: "Волны",
  BUBBLE: "Пузыри",
  TEMP_TYPE_ID: "Выберите дизайн",
  CLASSIC_1: "Классический 1",
  DESIGN_1: "Дизайн 1",

  /** Signup */
  SIGNUP: "Давайте начнем",
  SIGNUP_NFO: "Краткая регистрация, и вы в деле",
  USER_DETAILS: "Данные пользователя",
  BIZ_DETAILS: "Данные бизнеса",
  BIZ_TEL: "Телефон бизнеса",
  BIZ_EMAIL: "Электронная почта бизнеса",
  BIZ_DESC: "Информация о бизнесе",
  VALID_PASSWORD: "Подтверждение пароля",
  EMAIL_FOR_RESET_PASSWORD: "Электронная почта для сброса пароля",
  HAS_LOGIN: "Уже есть аккаунт?",

  /** businessCard */
  businessCard: "Визитная карточка",

  //** Analytics */
  ANALYTICS: "Аналитика",

  /** Private Area */
  PRIVATE_AREA: "Личный кабинет",

  /** plans */
  MAX_CLIENTS: "Количество клиентов",
  MAX_EMPLOYEES: "Количество сотрудников",
  MAX_ITEMS: "Количество товаров",
  MAX_WEBAPPMESSAGE: "Количество сообщений",
  YOUR_PLAN: "Ваш план",
  DELETE_PLAN: "Вы уверены, что хотите удалить этот пакет?",

  /** plugins */
  PLUGINS: "Плагины",
  PLUGINS_MANAGER: "Управление плагинами",
  MAX_QTY: "Максимальное количество",
  PROPERTIES: "Свойства",
  SELECT_PLUGIN: "Добавить плагин",
  REMOVE_PLUGIN: "Удалить плагин",
  REMOVE_PLUGIN_ASK: "Вы уверены, что хотите удалить",
  REMOVE_PLUGIN_INFO: "Ваша информация будет сохранена, но доступ к плагину и его функциям будет ограничен",
  REMOVE_AFTER_SAVE: "Обратите внимание - плагин будет удален только после нажатия кнопки продолжить",
  DELETE_PLUGIN: "Вы уверены, что хотите удалить этот плагин?",

  /** desktop */
  DASHBOARD: "Панель управления",
  STATUS_SERVICES_CALL: "Статус вызова сервиса",
  SUM: 'Итого',
  NOT_WORK_DT: "Без даты работы",
  NO_INVOICE_NUMBER: "Без номера счета",
  TOTAL_EXPENSES_PROVIDERS: "Общие расходы поставщиков",
  TOTAL_REVENUE: 'Общий доход',
  REVENUE: "Доход",

  /** Business */
  COLOR1: "Цвет 1",
  COLOR2: "Цвет 2",
  COLOR3: "Цвет 3",
  LOGO: "Логотип",
  IMAGE_HEADER: "Обложка для посадочных страниц",
  LAT_AND_LON: "Широта и долгота",
  DESC_BIZ_TITLE: "Заголовок для описания бизнеса",
  DESC_BIZ: "Описание бизнеса",
  IS_EXAMPLE: "Пример бизнеса",

  /** Departments */
  DEPARTMENTS: "Отделы",
  DEPARTMENT: "Отдел",
  MANAGER: "Менеджер",
  PLUGINS_LIST: "Список плагинов",
  ADD_PLUGINS: "Добавить плагин",
  SELECT_PLUGINS: "Выберите плагин",
  LINKED_PLUGINS: "Связанные плагины",

  /** Employee */
  EMPLOYEES: "Сотрудники",
  EMPLOYEE: "Сотрудник",
  ALL_EMPLOYEES: "Все сотрудники",
  EMPLOYEE_IMG: "Изображение сотрудника",
  CARDS: "Карты",
  CARD: "Карта",
  EMPLOYEE_DETAILS: "Данные сотрудника",
  FN: "Имя",
  LN: "Фамилия",
  BIZ_ROLE: "Роль в бизнесе",
  TEL: "Телефон",
  EMAIL: "Электронная почта",
  OF: "Из",
  CARD_QTY: "Количество карт",
  EMPLOYEES_QTY: "Количество сотрудников",
  EMPLOYEES_PATH: "Идентификатор сотрудника",
  BUSINESS_CARD: "Визитная карточка",
  WEB_APP_PAGE: "Посадочная страница",
  LOGIN_EMP: "Вход сотрудника",
  LOGIN_EMP_LINK: "Ссылка для входа сотрудника",
  OPEN_LINK: "Открыть ссылку",
  COPY_LINK: "Скопировать ссылку",
  USER_NAME_EXISTS: "Имя пользователя уже существует в системе - выберите другое имя",
  DELETE_EMPLOYEES: "Вы уверены, что хотите удалить этого сотрудника?",
  IS_BO_ALLOWED: "Доступ к панели",
  HAS_WEB: "Страница сотрудника",
  LOGIN_EMP_LINK_INFO: "Ссылка персональная и не подлежит передаче (у каждого сотрудника своя ссылка)",

  /** items */
  SKU: "Артикул",
  DESC: "Описание",
  IS_WEB_SALE: "Показано на сайте",
  NAME: "Название",
  WARRANTY_TIME: "Время гарантии (в днях)",
  DELETE_ITEM: "Вы уверены, что хотите удалить этот товар?",
  ITEMS_QTY: "Количество товаров",
  ITEM_DETAILS: "Данные товара",

  /** Clients */
  CLIENTS: "Клиенты",
  GET_CLIENTS_ERROR: "Ошибка при импорте клиентов",
  CLIENT_GUID: "Идентификатор клиента",
  COMPANY: "Название компании",
  CONTACT_NAME: "Контактное лицо",
  CLIENT_DETAILS: "Данные клиента",
  GUID_EXISTS: "Идентификатор существует, выберите другой",
  CLIENT_QTY: "Количество клиентов",
  ITEMS_LIST: "Список товаров",
  ADD_ITEM: "Добавить товар",
  ITEMS: "Товары",
  NEW_CLIENT: "Новый клиент",
  GUID: "Идентификатор",
  SELECT_ITEM: "Выберите товар",
  DELETE_CLIENT: "Вы уверены, что хотите удалить этого клиента?",
  ALL_CLIENTS: "Все клиенты",
  IS_BLOCKED: "Клиент заблокирован",

  /** Services call */
  SERVICE_CALL_ACTIVE: "Активные вызовы",
  SERVICE_CALL_APPROVAL: "Закрытые вызовы",
  SERVICE_CALL_HISTORY: "История",
  SERVICES_CALL: "Вызов/Заказ",
  CALL_ID: "Номер вызова",
  OPEN: "Открыто",
  SELECT_EMPLOYEE: "Прикрепленный сотрудник",
  PMT_TYPE_ID: "Статус оплаты",
  PAY: "Оплатить",
  NOT_PAY: "Без оплаты",
  SERVICE: "Сервис",
  WAITING: "Ожидание",
  NOTES: "Заметки",
  CLIENT_CALL_ID: "Номер вызова (клиент)",
  ALL_CALLS: "Все вызовы",
  JOB_DONE_DESC: "Выполненная работа",
  SELECT_EMP: "Выберите сотрудника",
  DESC_PROBLEM: "Описание проблемы",
  CREATE_SERVICES: "Создать новый вызов",
  IMPORT_CALL: "Импортировать вызовы",
  NEW_CALL: "Новый вызов",
  RESET: "Сброс",
  DELETE_SERVICES_CALL: "Вы уверены, что хотите удалить этот вызов?",
  WORK_DT: "Дата работы",
  DODAY: "Сегодня",
  CLIENT_NAME: "Контактное лицо",
  ORDER_NUM: "Номер заказа",
  INVOICE_NUM: "Номер счета",
  QUOTATION_NUM: "Номер предложения",
  CREATE_QR: "Создать QR",
  S_C: "К.С",
  DISPLAY_SETTINGS: "Настройки отображения",
  PROVIDERS: "Поставщики",
  CONTENT_WITH_ITEMS: "Описание проблемы",
  SEND_SEVICES_SUMMARY: "Отправить итог визита",
  OPEN_SEVICES_SUMMARY: "Открыть итог визита",
  CLIENT_NO_EMAIL: 'Невозможно отправить - у этого клиента нет электронной почты',
  CHANGE_DATES: "Изменить даты",
  START: "Начало",
  END: "Конец",
  PROVIDERS_EXPENSES: "Расходы поставщиков",
  SEND_SUCCESS: "Итог визита успешно отправлен",
  WORK_END_DT: "Конец работы",
  WORK_END_DT_ISBEFORE_WORK_DT_ERROR:
    "Дата окончания не может быть раньше начала работы",
  SUBMIT_AND_SEND_SUMMARY: "Сохранить и отправить",
  APPROVAL: "Одобрено",
  SELECT_DEPARTMENTS: "Выберите отдел",
  SELECT_CLIENT: "Выберите клиента",
  CREATE_SERVICE_CALL: "Создать вызов сервиса",

  /** Control And Monitoring */
  CONTROL_AND_MONITORING: "Контроль и мониторинг",
  TEMP1: "Возврат воздуха",
  TEMP2: "Выходящий воздух",
  LOADING_TO_DATA: "Ожидание...",
  ACTIVE_DATA: "Состояние кондиционера",
  ON_MC: "Включено",
  OFF_MC: "Выключено",
  TEMP_ACTIVE: "Температура",
  MODE_ACTIVE: "Режим",
  TURN_ON_DATE: "Дата включения",
  FAULT: "Ошибка",
  FAULTS: "Ошибки",
  CLOGGED_FILTER: "Похоже, что фильтр загрязнен - его нужно очистить",
  SENSOR_ERROR: "Один из датчиков неисправен - обратитесь в службу поддержки",
  LACK_GAS: "Похоже, что недостаточно газа - откройте вызов к технику",
  COMPRESSOR_NOT_STOP: "Компрессор не останавливается - необходимо немедленно проверить кондиционер",
  TURN_ON_DATE_INFO_RELAY: "Вы уверены, что хотите включить устройство?",
  TURN_OFF_DATE_INFO_RELAY: "Вы уверены, что хотите выключить устройство?",
  ALL_AREAS: "Все зоны",
  MC_IS_DISCONNECTED: "Контроллер не подключен к сети",

  /** Calendar */
  CALENDAR: "Календарь",
  LOCATION: "Местоположение",
  AVAILABILITY: "Доступность",
  AVAILABLE: "Свободно",
  BUSY: "Занято",
  PERSONAL: "Личное",
  VOLUNTEERING: "Волонтерство",
  SCHOOL: "Учеба",
  WORK: "Работа",
  FAMILY: "Семья",
  DELETE_EVENT: "Вы уверены, что хотите удалить это событие?",

  /** Meter Reading */
  METER_READING: "Считывание счетчиков",
  METER_ID: "Номер счетчика",
  READ_VALUE: "Считывание",
  ELECTRICITY: "Электричество",
  WATER: "Вода",
  GAS: "Газ",
  METER_READ: "Считывание счетчика",
  DELETE_METER_READ: "Вы уверены, что хотите удалить это считывание?",
  CREATED_READ: "Дата считывания",
  METER_LAST_READ: "Последнее показание счетчика",
  ERROR_DAY: "Ежедневное чтение выполнено",

  /** meter */
  METER_NAME: "Имя/Номер счетчика",
  METERS: "Счетчики",
  THERE_ARE_NO_METERS: "Нет доступных счетчиков для чтения, сначала откройте счетчик",
  SELECT_METER: "Выберите счетчик",

  /** Settings */
  BIZ_SETTINGS: "Настройки бизнеса",
  BIZ_NAME: "Название бизнеса",
  ADDR: "Адрес",

  /** contact us */
  CONTACT_US: "Связаться с нами",

  /** Smart Qr */
  SMART_QR: "Smart Qr",
  CONTACT: "Контакт",
  CLIENT_SERVICES_CALL: "Вызовы сервиса для клиента",
  QR_DETAILS: "Детали",
  CLIENT_ITEM: "Товар",
  CLIENT: "Клиент",
  TITLE_QR: "Заголовок (для внутреннего использования)",
  DELETE_SMART_QR: "Вы уверены, что хотите удалить этот Smart Qr?",
  TEXT: "Текст",
  LOCATION: "Местоположение",
  NAVIGATION: "Навигация",
  HAS_PASSWORD: "Защищено паролем",

  /** Appointments */
  APPOINTMENTS: "Запись на прием",

  /** Schedule */
  SCHEDULE: "Расписание",

  /** video Carousel */
  VIDEO_CAROUSEL: "Видео-карусель",
  VIDEO: "Видео",
  VIDEO_QTY: "Количество видео",
  VIDEO_URL: "Ссылка на видео",

  /** Micro Controllers Manager */
  MICRO_CONTROLLERS_MANAGER: "Управление контроллерами",
  MICRO_CONTROLLERS: "Контроллеры",
  MICRO_CONTROLLER: "Контроллер",
  MICRO_CONTROLLER_DETAILS: "Детали контроллера",
  AIR_CONDITIONER: "Кондиционер",
  LIGHTING: "Освещение",
  IS_LINKED_MC: "Прикреплен к контроллеру (с идентификатором)",
  MC_NOT_FOUND: "Контроллер не найден",
  CHECK_ACTIVATED: "Проверка контроллера",
  MC_HAPPY: "Контроллер исправен",
  MICRO_CONTROLLER_CREATE: "Создать контроллер",
  DELETE_MICRO_CONTROLLER: "Вы уверены, что хотите удалить этот контроллер?",
  ACTIVATED: "Активировано",
  MINI_DETAILS: "Основные данные",
  CONNECT_TO_WIFI: "Подключение к сети",
  MC_CONNECTED: "Контроллер подключен к сети",
  MC_DISCONNECTED: "Контроллер не подключен к сети",
  MC_ACTIVATED: "Контроллер уже в использовании",
  OUTSIDE_WORKING_HOURS: "Вне рабочего времени",
  OUTSIDE_WORKING_HOURS_MSG: "Ой, кажется, вы пытаетесь включить устройство после рабочего времени",
  OUTSIDE_WORKING_HOURS_MSG_1: "Нажмите на время, когда вы хотите включить устройство",
  ONE_HOUR: "Час",
  TWO_HOURS: "Два часа",
  THREE_HOURS: "Три часа",
  FOUR_HOURS: "Четыре часа",

  /** Areas */
  AREAS: "Зоны",
  AREA: "Зона",
  DELETE_AREA: "Вы уверены, что хотите удалить эту зону?",

  /** Webapp Message */
  WEBAPP_MESSAGE: "Почта",
  OPEN_MESSAGE: "Открыть сообщение",
  FULL_NAME: "Контактное лицо",
  IS_READ: "Статус сообщения",
  MESSAGE: "Сообщение",
  READ: "Сообщение прочитано",
  NOT_READ: "Сообщение не прочитано",
  SELECTED_EMP: "Выберите сотрудника",

  /** business manager */
  BUSINESS_MANAGER: "Управление бизнесом",
  NAVIGATE_BUSINESS: "Перейти к бизнесу",
  PATH: "Идентификатор",

  /** Ac Commands*/
  BRAND: "Бренд",
  MODEL: "Модель",
  VERSION: "Версия",
  YEAR_MANUFACTURE: "Год выпуска",
  REGION: "Регион продажи",
  ON: "Включение",
  OFF: "Выключение",
  VENT: "Вентиляция",
  COOL: "Холод",
  HEAT: "Тепло",
  DRY: "Осушение",
  AUTO: "Авто",
  ECO: "Эко",
  SLEEP: "Режим сна",
  TURBO: "Турбо",
  DEGREES: "Градусы",
  PROTOCOL: "Протокол",
  BITS: "Количество бит",
  MODES: "Режимы работы",
  POWER: "Включение и выключение",
  POWER_COMMANDS: "Включение и режимы работы",
  TEMPS_COMMANDS: "Температура",
  AC_COMMANDS_MANAGER: "Команды кондиционера",
  FAN_SPEED: "Скорость вентилятора",
  LOW: "Низкая",
  MEDIUM: "Средняя",
  HIGH: "Высокая",
  COMMANDS: "Команды",
  SELECT_COMMAND: "Выберите команды (обычно по бренду и модели кондиционера)",
  TEST_COMMAND_SUCCESS: "Команда отправлена контроллеру - если команда принята, кондиционер должен включиться",
  COMMAND_NOE_FOUND_ERROR: "Не выбран бренд кондиционера",
  WEEKLY_TIMES: "Расписание",
  RELAY: "Реле",
  DIFFERENCE: "Разница",

  /** reports */
  REPORTS: "Отчеты",
  INVOICE_STATUS: "Статус счета-фактуры",

  /** colors name */
  LIGHT_PINK: "Светло-розовый",
  LIGHT_YELLOW: "Светло-желтый",
  PALE_GREEN: "Бледно-зеленый",
  LIGHT_BLUE: "Светло-голубой",
  OFF_WHITE: "Цвет слоновой кости",
  LIGHT_LAVENDER: "Светло-лавандовый",
  SOFT_RED: "Мягкий красный",
  SOFT_CYAN: "Мягкий бирюзовый",
  SOFT_GOLD: "Мягкое золото",
  SOFT_MINT: "Мягкая мята",
  SOFT_LILAC: "Мягкий сиреневый",
};

export default ru;
